<template>
  <div id="app">
      <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">{{title}}</div>
                  <div class="clearfix"></div>
                </div>
                <datail :data="data"></datail>
                </div>
              </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import datail from '../components/new_datail'
import HomeHeader from '@/components/MasterTop'
  export default {
    data() {
      return {
        title:"",
        data:{},
        CommentList:[],
        comm: 0,
        isComment:false,
      }
    },
    components: {
      datail,
      HomeHeader
    },
    mounted(){
      var id = this.$route.query.ItemId;
      this.getdetailes(id)
      if(sessionStorage.getItem("SetItem")){
        let SetItem=JSON.parse(sessionStorage.getItem("SetItem"))
      SetItem.map((item)=>{
          if(item.SetItemID==230){
              item.Item_Value=="是"?this.isComment=true:this.isComment=false
          }
          if(item.SetItemID==6055){
              item.Item_Value=="是"?this.isEnzhaiy=true:this.isEnzhaiy=false
          }
          if(item.SetItemID==5000){
             this.ISSN=item.Item_Value
          }
          if(item.SetItemID==5010){
             this.CN=item.Item_Value
          }
          if(item.SetItemID==1000){
             this.setName=item.Item_Value
          }
      })
      }else{
        let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,11,2960,4553]
        this.$store.dispatch("_getSet",params).then(res=>{
          sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
          let SetItem=res.data.Data
          SetItem.map((item)=>{
          if(item.SetItemID==230){
              item.Item_Value=="是"?this.isComment=true:this.isComment=false
          }
          if(item.SetItemID==6055){
              item.Item_Value=="是"?this.isEnzhaiy=true:this.isEnzhaiy=false
          }
          if(item.SetItemID==5000){
             this.ISSN=item.Item_Value
          }
          if(item.SetItemID==5010){
             this.CN=item.Item_Value
          }
          if(item.SetItemID==1000){
             this.setName=item.Item_Value
          }
      })
        }).catch(err=>{
          console.log(err)
        })
      }
      
      this._getPLLB(id)
    },
    methods: {
      getdetailes(id){
        var time =new Date().getTime() 
        this.$store.dispatch('_getdetailes',id).then(res=>{
          this.title=res.data.Message
          this.data=res.data.Data
          document.title=res.data.Message
        }).catch(err=>{

        })
      },
      _getPLLB(id){
        var id = id
        let params = {
          Type: 2,
          ID: id,
          PageSize: 3
        }
        var a = sessionStorage.getItem('aa')
        if (a == 1) {
          params.Type = 4
        } else {
          params.Type = 2
        }
         this.$store.dispatch("_getPLLB",params)
        .then(res => {
          if (res.data.IsSuccess) {
            this.CommentList = res.data.Data
            this.comm = res.data.ItemCount
          }
        }).catch(err => {
          console.log("err", err)
        })
      },
    }
  }
</script>

<style>
.news_datail_con  a:hover{
color: #ff9f00 !important;
}
</style>
